import { Controller } from '@hotwired/stimulus'

// Formulaires de l'admin (gods/_form_page). Dans la modale web, le formulaire s'envoie dans la frame :
// un formulaire refusé (422) s'y réaffiche avec ses erreurs. Une fois enregistré, on suit la redirection
// pour recharger toute la page (le `target="_top"` de leur frame ne passe pas sur la frame déjà en
// place). Hors modale (dans l'app, le formulaire est une page), l'envoi vise toute la page, et
// `returnTo` (la page d'où l'on vient, cf. gods_edit_path) est renvoyé avec le formulaire pour y
// revenir à l'identique.
export default class extends Controller {
  static values = { returnTo: String }

  connect() {
    const inModal = !!this.element.closest('dialog')

    this.element.querySelectorAll('form').forEach((form) => {
      if (inModal) {
        form.addEventListener('turbo:before-fetch-response', this.#visitOnSuccess)
        return
      }

      form.dataset.turboFrame = '_top'
      if (!this.returnToValue || form.querySelector('input[name="return_to"]')) return

      const input = document.createElement('input')
      Object.assign(input, { type: 'hidden', name: 'return_to', value: this.returnToValue })
      form.append(input)
    })
  }

  // La page de la redirection est déjà chargée : on l'affiche telle quelle, sans la redemander (le
  // flash du contrôleur n'y survivrait pas).
  #visitOnSuccess = async (event) => {
    const { fetchResponse } = event.detail
    if (!fetchResponse.succeeded || !fetchResponse.redirected) return

    event.preventDefault()
    const { location, statusCode } = fetchResponse
    const action = location.href === window.location.href ? 'replace' : 'advance'
    const responseHTML = await fetchResponse.responseHTML
    window.Turbo.visit(location, { action, response: { statusCode, redirected: true, responseHTML } })
  }
}
